import React from "react";

import "./Layout.scss";

import { Header } from "../";

export type LayoutProps = {
  children?: React.ReactNode;
};

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="container">
      <div className="page">
        <Header />
        <main>{children}</main>
      </div>
      <div className="footer">
        <p className="text-center text-small">
          Made with joy by{" "}
          <a href="http://rewdy.lol" target="_blank" rel="noreferrer">
            rewdy
          </a>{" "}
          <span role="img" aria-label="joy">
            😂
          </span>
        </p>
      </div>
    </div>
  );
};
